import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import spartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":8,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section id=\"select-a-zip-single-modal\">\r\n    <div id=\"select-a-zip-single-modal-partial\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"single-zip-code-resolution-modal"),depth0,{"name":"single-zip-code-resolution-modal","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\r\n</section>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <section class=\"zip-code-locator-modal-layer-closing-costs-calculator\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":12},"end":{"line":50,"column":29}}})) != null ? stack1 : "")
    + "        </section>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n            <div class=\"content-col\">\r\n                <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n            </div>\r\n\r\n            <form id=\"zip_code_locator_modal\" novalidate>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":16},"end":{"line":35,"column":25}}})) != null ? stack1 : "")
    + "\r\n                <div class=\"buttons\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"buttons") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":20},"end":{"line":46,"column":29}}})) != null ? stack1 : "")
    + "                </div>\r\n            </form>\r\n\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"inputs\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","TEXT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":20},"end":{"line":28,"column":31}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","SELECT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":20},"end":{"line":33,"column":31}}})) != null ? stack1 : "")
    + "                </div>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"small-12 medium-5 column\">\r\n                        "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":26,"column":24},"end":{"line":26,"column":46}}})) != null ? stack1 : "")
    + "\r\n                    </div>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"small-12 medium-5 column\">\r\n                        "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"select","hash":{},"data":data,"loc":{"start":{"line":31,"column":24},"end":{"line":31,"column":43}}})) != null ? stack1 : "")
    + "\r\n                    </div>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"small-12 column change-zip-modal-button\">\r\n                        <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"URL") || (depth0 != null ? lookupProperty(depth0,"URL") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"URL","hash":{},"data":data,"loc":{"start":{"line":40,"column":33},"end":{"line":40,"column":42}}}) : helper)))
    + "\" class=\"spa-btn spa-btn--large spa-btn--"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"style") || (depth0 != null ? lookupProperty(depth0,"style") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"style","hash":{},"data":data,"loc":{"start":{"line":40,"column":83},"end":{"line":40,"column":94}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"coremetrics") || (depth0 != null ? lookupProperty(depth0,"coremetrics") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"coremetrics","hash":{},"data":data,"loc":{"start":{"line":40,"column":100},"end":{"line":40,"column":117}}}) : helper)))
    + "\">\r\n                            <span class=\"button-text\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":41,"column":54},"end":{"line":41,"column":63}}}) : helper)))
    + "</span>\r\n                            <span class=\"ada-hidden\"></span>\r\n                            <span class=\"spin\"></span>\r\n                        </a>\r\n                    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"select_a_zip_single_modal_layer") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":9,"column":9}}})) != null ? stack1 : "")
    + "\r\n<div class=\"row\">\r\n    <div class=\"column small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"zip_code_locator_modal") : stack1),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":52,"column":17}}})) != null ? stack1 : "")
    + "    </div>\r\n</div>\r\n";
},"usePartial":true,"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"inputs\">\r\n        <div class=\"small-12 column cnx-regular\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","SELECT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":10},"end":{"line":15,"column":21}}})) != null ? stack1 : "")
    + "        </div>\r\n      </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"small-12 medium-5 column\">\r\n              "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"select","hash":{},"data":data,"loc":{"start":{"line":13,"column":14},"end":{"line":13,"column":33}}})) != null ? stack1 : "")
    + "\r\n            </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"small-12 column change-zip-modal-button\">\r\n          <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"URL") || (depth0 != null ? lookupProperty(depth0,"URL") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"URL","hash":{},"data":data,"loc":{"start":{"line":24,"column":19},"end":{"line":24,"column":28}}}) : helper)))
    + "\" class=\"spa-btn spa-btn--large spa-btn--"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"style") || (depth0 != null ? lookupProperty(depth0,"style") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"style","hash":{},"data":data,"loc":{"start":{"line":24,"column":69},"end":{"line":24,"column":80}}}) : helper)))
    + "\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"coremetrics") || (depth0 != null ? lookupProperty(depth0,"coremetrics") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"coremetrics","hash":{},"data":data,"loc":{"start":{"line":24,"column":86},"end":{"line":24,"column":103}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":24,"column":105},"end":{"line":24,"column":116}}}) : helper)))
    + " </a>\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<section class=\"wrapper-single-zip-code-resolution-modal-closing-cost-caluclator\">\r\n  <div class=\"row\">\r\n    <div class=\"small-12\" ><p class=\"modal-para no-show cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p></div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n\r\n    <div class=\"row buttons\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"buttons") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":6},"end":{"line":26,"column":15}}})) != null ? stack1 : "")
    + "    </div>\r\n</section>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

/**
 * Handlebars Helpers: zip-code-locator-modal-module
 */
function ifCond(v1, operator, v2, options) {
  switch (operator) {
    case '==':
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    // eslint-disable-line
    case '===':
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case '<':
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case '<=':
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case '>':
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case '>=':
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case '&&':
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case '||':
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/zip-code-locator-modal-module",
  "version": "3.0.0",
  "id": "zipCodeLocatorModalModule",
  "containerID": "homeLoansZipCodeLocatorModalModule",
  "moduleName": "home-loans-zip-code-locator-modal-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "zipCodeLocatorModalModule",
  "data": {
    "init": "zipCodeLocatorModalModule"
  },
  "moduleParams": [{
    "name": "updateRates",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "If set to true, this module will trigger an event to update rates"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        ifCond,
        select,
        textInput,
        layerContent
      },
      "partials": {
        "single-zip-code-resolution-modal": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "single-zip-code-resolution-modal": renderTemplate
  },
  "helpers": {
    ifCond,
    select,
    textInput,
    layerContent
  },
  "dependencies": {
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.9",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint max-len: [2, 150] */
/**
 * @export
 * @class zipCodeLocatorModalModule
 * @extends {Module}
 */
class zipCodeLocatorModalModule extends Module {
  /**
   * Creates an instance of zipCodeLocatorModalModule.
   * @param {Object} options Moduel Options
   * @param {Object} context Moduel Context
   * @memberof zipCodeLocatorModalModule
   */
  constructor(options, context) {
    // extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#zipCodeLocatorModalModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
    this.$store = {};
  }

  /**
   * @param {Object} $region Region selector
   * @return {void}
   * @memberof zipCodeLocatorModalModule
   */
  validate($region) {
    const {
      validationCore
    } = this;
    const $requiredInputs = $region.find('[required]');
    const allRequiredValuesProvided = validationCore.validateRequiredFields($requiredInputs);
    const $inputs = $region.find('[data-validation-rules]:visible');
    const validationResults = $inputs.map((idx, input) => {
      const $input = $(input);
      return validationCore.validateRules($input, this.validationRules[$input.attr('id')].change);
    });
    return allRequiredValuesProvided && _.every(validationResults);
  }

  /**
   * @param {Object} $input Input selector
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  appendErrorContainer($input) {
    const $errorContainer = $input.siblings('div.spa-input-error-message');
    if (!$errorContainer.length) {
      $input.parent().append(`<div id="${$input.attr('id')}_errorMessage" class="spa-input-error-message spa-icon--error" aria-hidden="true"></div>`);
    }
  }

  /**
   * @param {Object} $input Input Selector
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  clearError($input) {
    const $label = $input.siblings('label');
    // this.appendErrorContainer($input);
    const $errorContainer = $input.siblings('div.spa-input-error-message');
    $errorContainer.hide();
    spartaInputErrorUtility.updateInlineError(false, {
      field: $input,
      label: $label
    });
  }

  /**
   * @param {Object} $input user input
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  showError($input) {
    const $label = $input.siblings('label');
    // this.appendErrorContainer($input);
    const $errorContainer = $input.siblings('div.spa-input-error-message');
    $errorContainer.show();
    const message = $input.data('validation-message');
    setTimeout(() => spartaInputErrorUtility.updateInlineError(true, {
      field: $input,
      label: $label,
      message
    }), 500);
  }

  /**
   * @method zipCodeSubmitted
   */
  // eslint-disable-next-line
  zipCodeSubmitted() {
    // cache selectors
    const $cityStateInformationArea = $('form#zip_code_locator_modal');
    const $city = $cityStateInformationArea.find('#changeCityInput');
    const $stateField = $cityStateInformationArea.find('#changeStateInput');
    const state = $stateField.val().trim();
    if (state) {
      this.clearError($stateField);
    } else {
      this.showError($stateField);
    }
    if (!this.validate($cityStateInformationArea)) {
      return false;
    }
    const city = $city.val().toLowerCase();
    this.Events.pub('HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT', {
      city,
      state
    });
    this.toggleSpinner();
  }

  /**
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  toggleSpinner() {
    const $spinner = $('#find_state_city_zip_code_modal_link .spin');
    $spinner.toggleClass('spinner');
  }

  /**
   *
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  zipFailure() {
    this.toggleSpinner();
    this.showError($('#changeCityInput'));
  }

  /**
   * @param {object} response ask later
   * @return {void}
   * @memberof zipCodeLocatorModalModule
   */
  zipSuccess(response) {
    const payload = response.data;
    this.toggleSpinner();
    // check if it has error message in service payload
    const errorExist = payload.errorMessage;
    if (errorExist) {
      this.showError($('#changeCityInput'));
      return;
    }
    $('#selectMultipleZipInput').empty().append(payload.zipCodes.map(code => `<option value="${code}">${code}</option>`).join());
    spartaUILayersUtility.closeLayer();
    $('body').css('overflow', 'scroll');
    if (payload.zipCodes.length > 1) {
      $('.modal-para').removeClass('no-show');
    }

    // opens the partial modal layer
    spartaUILayersUtility.openLayer('#select_a_zip_single_modal_layer');
    $('#selectMultipleZipInput').on('change', this.handleChange.bind(this));

    // triggers click event for "select" button once a zip is selected
    $('#select_a_zip_dropdown_modal_link').on('click', this.zipSelect);
  }

  /**
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  zipSelect() {
    const $zipCodeSelector = $('#selectMultipleZipInput');
    const zipCode = $zipCodeSelector.val();
    if (!zipCode) {
      this.showError($zipCodeSelector);
    } else {
      this.clearError($zipCodeSelector);
      if (this.params.updateRates) {
        this.Events.pub('zip-code-change-submit:calculator-module', {
          postalCode: zipCode
        });
      } else {
        $('#zip-code-input').val(zipCode).focusin().blur();
        spartaUILayersUtility.closeLayer();
        $('body').css('overflow', 'scroll');
      }
    }
  }

  /**
   * @param {Object} e event handler
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  handleChange(e) {
    const $input = $(e.target);
    if (e.target.value) {
      this.clearError($input);
    } else {
      this.showError($input);
    }
  }

  /**
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  initializeSpartaValidationRules() {
    // eslint-disable-next-line
    const validationRules = this.validationRules = _.fromPairs(this.$target.find('[data-validation-rules]').map(function () {
      const $this = $(this);
      return [[$this.attr('id'), $this.data('validation-rules')]];
    }));

    // eslint-disable-next-line
    const validationCore = this.validationCore = spartaValidationFramework.fn.core;
    validationCore.bindValidationRules(validationRules, true);

    // separate handling of "required" validations
    this.$target.find('[required]').each(function requiredEach() {
      const $input = $(this);
      $input.on('blur', () => {
        if (!$input.val()) {
          validationCore.validateRequiredFields($input);
        }
      });
    });
  }

  /**
   * @memberof zipCodeLocatorModalModule
   * @return {void}
   */
  init() {
    const $zipCodeLocatorModal = $('#zip_code_locator_modal');
    $zipCodeLocatorModal.find('#find_state_city_zip_code_modal_link').on('click', this.zipCodeSubmitted);

    // listen for 'zip code lookup' service events
    this.Events.sub('HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS', this.zipSuccess);
    this.Events.sub('HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE', this.zipFailure);
    $zipCodeLocatorModal.spartaInputs();
    this.initializeSpartaValidationRules();
    $('#changeStateInput').on('change', this.handleChange.bind(this));
  }
}
registerModuleClass({
  moduleClass: zipCodeLocatorModalModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { zipCodeLocatorModalModule as default, moduleConfig };
